import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, concatMap, map, tap } from 'rxjs/operators';
import { ApiService } from 'projects/access-control/src/app/Infrastructure/Services/api.service';
import { of } from 'rxjs';
import { GroupService } from './groups.service';
import {
	createStatusGroup,
	createStatusGroupError,
	createStatusGroupSuccess,
	deleteBulkUsersGroups,
	deleteBulkUsersGroupsError,
	deleteBulkUsersGroupsSuccess,
	deleteGroup,
	deleteGroupError,
	deleteGroupSuccess,
	deleteStatusGroup,
	deleteStatusGroupError,
	deleteStatusGroupSuccess,
	getAllGroup,
	getAllGroupError,
	getAllGroupSuccess,
	getDetailGroups,
	getDetailGroupsError,
	getDetailGroupsSuccess,
	getGroup,
	getGroupError,
	getGroupSuccess,
	getSubGroups,
	getSubGroupsError,
	getSubGroupsSuccess,
	getUsersGroups,
	getUsersGroupsError,
	getUsersGroupsSuccess,
	postGroup,
	postGroupError,
	postGroupSuccess,
	postUsersGroups,
	postUsersGroupsError,
	postUsersGroupsSuccess,
	searchUsersGroups,
	searchUsersGroupsError,
	searchUsersGroupsSuccess,
	updateGroup,
	updateGroupError,
	updateGroupSuccess,
	updateSelectedGroup,
	updateSelectedGroupError,
	updateSelectedGroupSuccess,
	updateStatusGroup,
	updateStatusGroupError,
	updateStatusGroupSuccess,
	updateUsersGroups,
	updateUsersGroupsError,
	updateUsersGroupsSuccess,
} from './groups.action';
import { ToastAlert } from 'projects/access-control/src/app/Infrastructure/hooks/toast.hook';
import { Pagination } from 'projects/access-control/src/app/Domain/Entities/pagination.interface';
import { TranslateService } from '@mangosoft/mango-layout';

@Injectable()
export class GroupEffects {
	dataTranslate: any;
	constructor(
		private actions$: Actions,
		private api: ApiService,
		private groupService: GroupService,
		private toastAlert: ToastAlert,
		private translateService: TranslateService
	) {
		this.translateService.init('AccessControl').subscribe((data) => {
			this.dataTranslate = data.pages.groups.toasts;
		});
	}

	getGroups$ = createEffect(() =>
		this.actions$.pipe(
			ofType(getGroup),
			concatMap(() =>
				this.groupService.getGroups().pipe(
					map(({ data }) => getGroupSuccess({ group: data })),
					catchError((error) => of(getGroupError({ error })))
				)
			)
		)
	);

	getAllGroups$ = createEffect(() =>
		this.actions$.pipe(
			ofType(getAllGroup),
			concatMap(() =>
				this.groupService.getAllGroups().pipe(
					map(({ data }) => getAllGroupSuccess({ groups: data })),
					catchError((error) => of(getAllGroupError({ error })))
				)
			)
		)
	);

	getDetailgroups$ = createEffect(() =>
		this.actions$.pipe(
			ofType(getDetailGroups),
			concatMap(({ url }) =>
				this.groupService.getDetailGroup(url).pipe(
					map(({ data }) => getDetailGroupsSuccess({ detailGroups: data })),
					catchError((error) => of(getDetailGroupsError({ error })))
				)
			)
		)
	);
	getSubGroup$ = createEffect(() =>
		this.actions$.pipe(
			ofType(getSubGroups),
			concatMap(({ pk, sk }) =>
				this.groupService.getSubGroup(pk, sk).pipe(
					map(({ data }) => getSubGroupsSuccess({ group: data })),
					catchError((error) => of(getSubGroupsError({ error })))
				)
			)
		)
	);
	addGroup$ = createEffect(() =>
		this.actions$.pipe(
			ofType(postGroup),
			concatMap(({ group }) =>
				this.groupService.createGroup(group).pipe(
					map(({ data }) => postGroupSuccess({ group: data })),
					catchError((error) => of(postGroupError({ error })))
				)
			)
		)
	);

	updateGroup$ = createEffect(() =>
		this.actions$.pipe(
			ofType(updateGroup),
			concatMap(({ group, ids }) =>
				this.groupService.updateGroup(group, ids).pipe(
					map(({ response }) => updateGroupSuccess({ group: response.data })),
					catchError((error) => of(updateGroupError({ error })))
				)
			)
		)
	);

	updateSelectedGroup$ = createEffect(() =>
		this.actions$.pipe(
			ofType(updateSelectedGroup),
			concatMap(({ group, ids }) =>
				this.groupService.updateGroup(group, ids).pipe(
					map(({ response }) => updateSelectedGroupSuccess({ group: response.data })),
					catchError((error) => of(updateSelectedGroupError({ error })))
				)
			)
		)
	);

	createStatusSelectedGroup$ = createEffect(() =>
		this.actions$.pipe(
			ofType(createStatusGroup),
			concatMap(({ group, ids }) =>
				this.groupService.updateGroup(group, ids).pipe(
					map(({ response }) => createStatusGroupSuccess({ group: response.data })),
					catchError((error) => of(createStatusGroupError({ error })))
				)
			)
		)
	);

	updateStatusSelectedGroup$ = createEffect(() =>
		this.actions$.pipe(
			ofType(updateStatusGroup),
			concatMap(({ group, ids }) =>
				this.groupService.updateGroup(group, ids).pipe(
					map(({ response }) => updateStatusGroupSuccess({ group: response.data })),
					catchError((error) => of(updateStatusGroupError({ error })))
				)
			)
		)
	);

	deleteStatusSelectedGroup$ = createEffect(() =>
		this.actions$.pipe(
			ofType(deleteStatusGroup),
			concatMap(({ group, ids }) =>
				this.groupService.updateGroup(group, ids).pipe(
					map(({ response }) => deleteStatusGroupSuccess({ group: response.data })),
					catchError((error) => of(deleteStatusGroupError({ error })))
				)
			)
		)
	);

	deleteGroup$ = createEffect(() =>
		this.actions$.pipe(
			ofType(deleteGroup),
			concatMap(({ ids }) =>
				this.groupService.deleteGroup(ids).pipe(
					map(({ data }) => deleteGroupSuccess({ ids: data })),
					catchError((error) => of(deleteGroupError({ error })))
				)
			)
		)
	);

	//Users

	getUsersGroup$ = createEffect(() =>
		this.actions$.pipe(
			ofType(getUsersGroups),
			concatMap(({ group, paginationTo }) =>
				this.groupService.getUsersGroup(group, paginationTo).pipe(
					map(({ data, pagination }) =>
						getUsersGroupsSuccess({
							user: data.users,
							pagination: pagination,
						})
					),
					catchError((error) => of(getUsersGroupsError({ error })))
				)
			)
		)
	);

	searchUsersGroup$ = createEffect(() =>
		this.actions$.pipe(
			ofType(searchUsersGroups),
			concatMap(({ group, url }) =>
				this.groupService.searchUsersGroup(group, url).pipe(
					map(({ data, pagination }) =>
						searchUsersGroupsSuccess({
							user: data.users,
							pagination: pagination,
						})
					),
					catchError((error) => of(searchUsersGroupsError({ error })))
				)
			)
		)
	);

	postUsersGroup$ = createEffect(() =>
		this.actions$.pipe(
			ofType(postUsersGroups),
			concatMap(({ user }) =>
				this.groupService.createUsersGroup(user).pipe(
					map(({ data }) => postUsersGroupsSuccess({ user: data })),
					catchError((error) => of(postUsersGroupsError({ error })))
				)
			)
		)
	);

	updateUsersGroup$ = createEffect(() =>
		this.actions$.pipe(
			ofType(updateUsersGroups),
			concatMap(({ user, idsUser }) =>
				this.groupService.updateUsersGroup(user, idsUser).pipe(
					map(({ data }) => updateUsersGroupsSuccess({ user: data })),
					catchError((error) => of(updateUsersGroupsError({ error })))
				)
			)
		)
	);

	bulkDeleteUsersGroup$ = createEffect(() =>
		this.actions$.pipe(
			ofType(deleteBulkUsersGroups),
			concatMap(({ user, ids }) =>
				this.groupService.bulkDeleteGroup(user, ids).pipe(
					map(({ data }) => deleteBulkUsersGroupsSuccess({ user: data })),
					catchError((error) => of(deleteBulkUsersGroupsError({ error })))
				)
			)
		)
	);

	//Alerts
	addGroupSuccess$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(postGroupSuccess),
				tap((action) => {
					this.toastAlert.toastSuccess(
						this.dataTranslate.toastCreateTitle,
						this.dataTranslate.toastCreateDescription
					);
				})
			),
		{ dispatch: false }
	);

	deleteGroupSuccess$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(deleteGroupSuccess),
				tap((action) => {
					this.toastAlert.toastSuccess(
						this.dataTranslate.toastDeleteTitle,
						this.dataTranslate.toastDeleteDescription
					);
				})
			),
		{ dispatch: false }
	);
	updateGroupSuccess$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(updateGroupSuccess, updateSelectedGroupSuccess),
				tap((action) => {
					this.toastAlert.toastSuccess(
						this.dataTranslate.toastUpdateTitle,
						this.dataTranslate.toastUpdateDescription
					);
				})
			),
		{ dispatch: false }
	);

	addUsersGroupSuccess$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(postUsersGroupsSuccess),
				tap((action) => {
					this.toastAlert.toastSuccess(
						this.dataTranslate.toastCreateUserTitle,
						this.dataTranslate.toastCreateUserDescription
					);
				})
			),
		{ dispatch: false }
	);

	deleteUsersGroupSuccess$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(deleteBulkUsersGroupsSuccess),
				tap((action) => {
					this.toastAlert.toastSuccess(
						this.dataTranslate.toastDeleteUserTitle,
						this.dataTranslate.toastDeleteUserDescription
					);
				})
			),
		{ dispatch: false }
	);
	updateUsersGroupSuccess$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(updateUsersGroupsSuccess),
				tap((action) => {
					this.toastAlert.toastSuccess(
						this.dataTranslate.toastUpdateUserTitle,
						this.dataTranslate.toastUpdateUserDescription
					);
				})
			),
		{ dispatch: false }
	);

	addStatusSuccess$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(createStatusGroupSuccess),
				tap((action) => {
					this.toastAlert.toastSuccess(
						this.dataTranslate.toastCreateStatusTitle,
						this.dataTranslate.toastCreateStatusDescription
					);
				})
			),
		{ dispatch: false }
	);

	updateStatusSuccess$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(updateStatusGroupSuccess),
				tap((action) => {
					this.toastAlert.toastSuccess(
						this.dataTranslate.toastUpdateStatusTitle,
						this.dataTranslate.toastUpdateStatusDescription
					);
				})
			),
		{ dispatch: false }
	);

	deleteStatusSuccess$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(deleteStatusGroupSuccess),
				tap((action) => {
					this.toastAlert.toastSuccess(
						this.dataTranslate.toastDeleteStatusTitle,
						this.dataTranslate.toastDeleteStatusDescription
					);
				})
			),
		{ dispatch: false }
	);

	groupsError$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(
					updateGroupError,
					postGroupError,
					getSubGroupsError,
					getDetailGroupsError,
					getGroupError,
					deleteGroupError,
					getUsersGroupsError,
					postUsersGroupsError,
					getAllGroupError,
					updateUsersGroupsError,
					updateSelectedGroupError,
					deleteBulkUsersGroupsError,
					updateStatusGroupError,
					createStatusGroupError,
					deleteStatusGroupError,
					searchUsersGroupsError
				),
				tap(({ error }) => {
					const msgError = error.error.errorMessage || 'Internal Error ';
					this.toastAlert.toastFailure('Error', msgError);
				})
			),
		{ dispatch: false }
	);
}
